import {
  File, Film, Image, UploadCloud,
} from 'react-feather';
import { ErrorCodes, FileTypes } from '../constants';
import { formatBytes } from '../../../../utils/shape-utils';

export const getErrorMessageByCode = (getTranslation, error, maxSize) => {
  const { code, message } = error || {};

  switch (code) {
    case ErrorCodes.LARGE_FILE_ERROR_CODE: {
      const { size, unit } = formatBytes(maxSize) || {};
      return getTranslation('MAX_ALLOWED_FILE_SIZE', { size: `${size}${unit}` });
    }

    default:
      return message;
  }
};

export const getIconBasedOnType = (mimeType = '') => {
  const mimeTypeParts = mimeType.split('/');

  switch (mimeTypeParts[0]) {
    case FileTypes.IMAGE:
      return Image;

    case FileTypes.APPLICATION:
      return File;

    case FileTypes.AUDIO:
    case FileTypes.VIDEO:
      return Film;

    default:
      return UploadCloud;
  }
};
